import { api } from "@api/api";
import { Landing } from "@modules/landings/types";
import { LandingFormValues } from "@modules/landings/validations";

export async function editLandingService(id: string, data: Partial<LandingFormValues>): Promise<Landing> {
  const { phone_image, ...body } = data;
  const payload = !phone_image ? { ...body, phone_image: null } : body;

  const { data: landing } = await api.patch<Landing>(`v1/landing_admin/${id}/`, payload);

  if (phone_image && phone_image instanceof File) {
    const formData = new FormData();
    formData.append("phone_image", phone_image);

    const { data: landing } = await api.patch<Landing>(`v1/landing_admin/${id}/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return landing;
  }

  return landing;
}
